import React, { useRef, useEffect } from "react";
import { MdSettings } from "react-icons/md";

const SpeedControl = ({ speed, onSpeedChange, showSpeedOptions, setShowSpeedOptions }) => {
  const speedRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (speedRef.current && !speedRef.current.contains(event.target)) {
        setShowSpeedOptions(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [setShowSpeedOptions]);

  return (
    <div className="relative" ref={speedRef}>
      <button
        onClick={() => setShowSpeedOptions((v) => !v)}
        className="transition"
        aria-label="Speed settings"
      >
        <MdSettings size={18} />
      </button>
      {showSpeedOptions && (
        <ul className="absolute bottom-full mb-2 bg-white bg-opacity-80 rounded shadow z-50 p-2 w-24 text-black">
          {[2, 1.5, 1, 0.75, 0.5].map((s) => (
            <li
              key={s}
              onClick={() => {
                onSpeedChange(s);
                setShowSpeedOptions(false);
              }}
              className={`px-2 py-1 rounded cursor-pointer hover:bg-white/70 ${
                speed === s ? "bg-purple-400 font-semibold" : ""
              }`}
            >
              {s === 1 ? "Normal" : `${s}x`}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SpeedControl;
